import { DEFAULT_ORG_CODE } from '../../const/orgInfo';
import { ILanguageItem } from '../../interfaces/api/I-api-language';
import { axiosInstance } from '../axiosInstance';

const adminLanguageURLInfo = {
  url: {
    list: '/api/v1/admin-mg-tp/language/list',
    add: '/api/v1/admin-mg-tp/language/add',
  },
};

export const languageInfoListApi = () => {
  const { url } = adminLanguageURLInfo;

  return axiosInstance.post(url.list, {
    cmd: '1702',
    orgcode: DEFAULT_ORG_CODE,
  });
};

/**
 * @deprecated 멀티조직도 현재는 사용 안함 추후 사용예정
 */
export const languageAddApi = (body: ILanguageItem[]) => {
  const { url } = adminLanguageURLInfo;

  return axiosInstance.post(url.add, {
    cmd: '1701',
    orgcode: DEFAULT_ORG_CODE,
    what: body,
  });
};
